@if (alert()) {
  <div class="alert-container"
    [class.success]="alert()?.type === 'success'"
    [class.error]="alert()?.type === 'error'"
    [class.alert]="alert()?.type === 'alert'"
    [@fadeInOut]
  >
    <h3>{{ title() | translate }}</h3>
    <p>{{ message() | translate }}</p>
  </div>
}
